import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../components/AuthContext';
import { getAuth, signOut } from 'firebase/auth';
import landingConfig from '../../config/landing.config';

const NAV_LINKS = [
  { to: '/seller', label: 'Dashboard' },
  { to: '/seller/leads', label: 'Leads' },
  { to: '/seller/proposals', label: 'Propuestas' },
  { to: '/seller/invoices', label: 'Facturas' },
  { to: '/seller/clients', label: 'Clientes' },
];

const SellerNavbar = () => {
  const location = useLocation();
  const { logout } = useAuth();
  const { logo = '/logo-prwd.svg', siteName = 'Puerto Rico Windows & Doors' } = landingConfig;

  const handleLogout = async () => {
    try {
      const auth = getAuth();
      await signOut(auth);
    } catch (err) {
      console.warn('No se pudo cerrar sesión en Firebase:', err.message);
    }
    logout();
  };

  return (
    <header className="bg-white border-b border-gray-200 shadow-sm px-4 lg:px-8 py-4 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex items-center gap-3">
        <img src={logo} alt={siteName} className="h-10 w-auto object-contain" />
        <div>
          <p className="text-xs uppercase tracking-[0.35em] text-emerald-600">Panel de ventas</p>
          <h1 className="text-lg font-semibold text-gray-900">Puerto Rico Windows & Doors</h1>
        </div>
      </div>
      <nav className="flex flex-col gap-2 lg:flex-row lg:items-center lg:gap-4">
        <div className="flex flex-wrap gap-2">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`rounded-full px-3 py-1.5 text-sm font-medium ${
                location.pathname === link.to
                  ? 'bg-emerald-600 text-white shadow'
                  : 'bg-gray-100 text-gray-600 hover:text-gray-900'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
        <button
          type="button"
          onClick={handleLogout}
          className="text-sm font-semibold text-gray-500 hover:text-gray-900"
        >
          Cerrar sesión
        </button>
      </nav>
    </header>
  );
};

export default SellerNavbar;
